import { Headline } from '../../../components/Headline';
import { Playground } from '../../../components/playground/Playground';
import FormLabel from '@rio-cloud/rio-uikit/FormLabel';

export const IconTextAlignment = () => {
    return (
        <div className='uikit-icons'>
            <Headline headlineType='h3' anchor='customIcons'>
                Icon text alignment
            </Headline>
            <Playground example={alignmentExample} />
        </div>
    );
};

const alignmentExample = (
    <div>
        <p>
            When an icon is used alongside text in a flex, grid, or inline text layout, additional alignment adjustments
            may be needed. To ensure proper alignment, the following classes are available:
        </p>
        <ul className='space-y-5'>
            <li>
                <code>uikit-icon-align-top</code> - assuming a display-flex and default line-height
            </li>
            <li>
                <code>uikit-icon-align-bottom</code> - assuming a display-flex and line-height 1.25
            </li>
            <li>
                <code>uikit-icon-align-baseline</code> - assuming an inline text and default line-height
            </li>
        </ul>
        <div>These classes help align icons correctly within different layouts where they are used alongside text.</div>
        <div className='margin-top-10 padding-bottom-10'>
            <b>Note</b>: Setting a text line-height class will also affect the icon alignment and may require manual
            adjustments to ensure proper positioning.
        </div>
        <div className='margin-top-25 display-grid grid-cols-1 grid-cols-2-sm gap-25'>
            <div>
                <FormLabel>
                    <b>Baseline</b>-aligned icon with <b>inline text</b>
                </FormLabel>
                <div className='bg-lightest padding-15 rounded'>
                    <span className='uikit-icon icon-face-smile uikit-icon-align-baseline' /> Lorem ipsum dolor
                </div>
            </div>

            <div>
                <FormLabel>
                    <b>Top</b>-aligned icon with text inside a <b>flex</b>-box layout
                </FormLabel>
                <div className='bg-lightest padding-15 rounded display-flex align-items-start gap-5'>
                    <span className='uikit-icon icon-face-smile uikit-icon-align-top' />
                    <span>Malesuada tincidunt. sem. In ante scelerisque adipiscing et enim</span>
                </div>
            </div>

            <div>
                <FormLabel>
                    <b>Bottom</b>-aligned icon inside an <b>inline-flex</b> layout and <b>line-height-125rel</b>
                </FormLabel>
                <div className='bg-lightest padding-15 rounded display-inline-flex align-items-start gap-5 line-height-125rel width-100pct'>
                    <span className='uikit-icon icon-face-smile uikit-icon-align-bottom' />
                    <span>Malesuada tincidunt. sem. In ante scelerisque adipiscing et enim</span>
                </div>
            </div>

            <div>
                <FormLabel>Icons inside a link usually don't need to be aligned manually</FormLabel>
                <div className='bg-lightest padding-15 rounded width-auto'>
                    <a href='#'>
                        <span className='uikit-icon icon-truck' />
                        <span>Lorem ipsum</span>
                    </a>
                </div>
            </div>

            <div>
                <FormLabel>
                    <b>Baseline</b>-aligned icon inside an inline h3 header text
                </FormLabel>
                <div className='bg-lightest padding-15 rounded width-auto text-color-darker'>
                    <h3 className='margin-0'>
                        <span className='uikit-icon icon-truck uikit-icon-align-baseline' />
                        <span> Primis ante volutpat Vivamus</span>
                    </h3>
                    <div className='text-size-h3 text-bold margin-top-10'>
                        <span className='uikit-icon icon-truck uikit-icon-align-baseline' />
                        <span> Primis ante volutpat Vivamus</span>
                    </div>
                </div>
            </div>

            <div>
                <FormLabel>
                    <b>Baseline</b>-aligned icon inside an inline h4 header text
                </FormLabel>
                <div className='bg-lightest padding-15 rounded width-auto text-color-darker'>
                    <h4 className='margin-0'>
                        <span className='uikit-icon icon-truck uikit-icon-align-baseline' />
                        <span> Primis ante volutpat Vivamus</span>
                    </h4>
                    <div className='text-size-h4 text-bold margin-top-10'>
                        <span className='uikit-icon icon-truck uikit-icon-align-baseline' />
                        <span> Primis ante volutpat Vivamus</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
);
